<ng-container *ngIf="!!get">
    <div class="height-full" style="display: flex">
        <div style="display: flex; flex-direction: column; gap: 0.5rem; flex: 2">
            <tt-field-group style="align-items: stretch">
                <tt-card ttHeading="docpack_background_template">
                    <tt-file-uploader
                        ttLabelView="none"
                        ttLabel="docpack_background_template"
                        ttDropZone
                        ttMultiple="false"
                        ttAccept=".pdf"
                        [(ttFiles)]="files"
                        (ttFilesChange)="onFilesChanged()"
                    ></tt-file-uploader>
                    <tt-field-group>
                        <tt-input-number ttLabelView="top" ttLabel="margin_top" [(ttModel)]="get.margin_top" (ttModelChange)="getChange$.next()" style="min-width: 7rem"></tt-input-number>
                        <tt-input-number ttLabelView="top" ttLabel="margin_right" [(ttModel)]="get.margin_right" (ttModelChange)="getChange$.next()" style="min-width: 7rem"></tt-input-number>
                        <tt-input-number ttLabelView="top" ttLabel="margin_bottom" [(ttModel)]="get.margin_bottom" (ttModelChange)="getChange$.next()" style="min-width: 7rem"></tt-input-number>
                        <tt-input-number ttLabelView="top" ttLabel="margin_left" [(ttModel)]="get.margin_left" (ttModelChange)="getChange$.next()" style="min-width: 7rem"></tt-input-number>
                    </tt-field-group>
                </tt-card>
                <tt-card ttHeading="page_number">
                    <tt-field-group>
                        <tt-checkbox
                            ttLabelView="top"
                            ttLabel="show_pagenumber"
                            [(ttModel)]="get.show_pagenumber"
                            (ttModelChange)="getChange$.next()"
                            [ttTrueValue]="true"
                            [ttFalseValue]="false"
                        ></tt-checkbox>
                        <tt-checkbox
                            [hidden]="get.show_pagenumber !== true"
                            ttLabelView="top"
                            ttLabel="show_pagenumber_firstpage"
                            [(ttModel)]="get.show_pagenumber_firstpage"
                            (ttModelChange)="getChange$.next()"
                            [ttTrueValue]="true"
                            [ttFalseValue]="false"
                        ></tt-checkbox>
                    </tt-field-group>
                    <tt-field-group>
                        <tt-input-number ttLabelView="top" ttLabel="fontsize" [(ttModel)]="get.pagenumber_fontsize" (ttModelChange)="getChange$.next()" style="min-width: 7rem"></tt-input-number>
                        <tt-color-input ttLabelView="top" ttLabel="textcolor" [(ttModel)]="get.pagenumber_color" (ttModelChange)="getChange$.next()"></tt-color-input>
                    </tt-field-group>
                    <tt-field-group>
                        <tt-input-number ttLabelView="top" ttLabel="x" [(ttModel)]="get.pagenumber_x" (ttModelChange)="getChange$.next()" style="min-width: 7rem"></tt-input-number>
                        <tt-input-number ttLabelView="top" ttLabel="y" [(ttModel)]="get.pagenumber_y" (ttModelChange)="getChange$.next()" style="min-width: 7rem"></tt-input-number>
                    </tt-field-group>
                </tt-card>
            </tt-field-group>
            <tt-card *ngFor="let style of formatElements" [ttIcon]="style.icon" [ttHeading]="style.element" ttTranslateHeading="false">
                <tt-field-group>
                    <tt-select
                        ttLabelView="top"
                        ttLabel="fontfamily"
                        [(ttModel)]="style.fontfamily"
                        [ttData]="fontFamilies"
                        (ttModelChange)="formatElementsChange$.next()"
                        style="min-width: 7rem"
                    ></tt-select>
                    <tt-select
                        ttLabelView="top"
                        ttLabel="fontstyle"
                        [(ttModel)]="style.fontstyle"
                        [ttData]="fontStyles"
                        (ttModelChange)="formatElementsChange$.next()"
                        style="min-width: 7rem"
                    ></tt-select>
                    <tt-select
                        ttLabelView="top"
                        ttLabel="textalign"
                        [(ttModel)]="style.textalign"
                        [ttData]="textAligns"
                        (ttModelChange)="formatElementsChange$.next()"
                        style="min-width: 7rem"
                    ></tt-select>
                    <tt-input-number ttLabelView="top" ttLabel="fontsize" [(ttModel)]="style.fontsize" (ttModelChange)="formatElementsChange$.next()" style="min-width: 7rem"></tt-input-number>
                </tt-field-group>
                <tt-field-group>
                    <tt-color-input ttLabelView="top" ttLabel="textcolor" [(ttModel)]="style.textcolor" (ttModelChange)="formatElementsChange$.next()"></tt-color-input>
                    <!-- <tt-color-input ttLabelView="top" ttLabel="backgroundcolor" [(ttModel)]="style.backgroundcolor" (ttModelChange)="formatElementsChange$.next()"></tt-color-input> -->
                </tt-field-group>
            </tt-card>
            <tt-card ttHeading="additional_styling" ttIcon="far fa-code" ttAccordion>
                <tt-textarea ttLabelView="top" ttLabel="additional_styling" [(ttModel)]="get.additional_styling"></tt-textarea>
            </tt-card>
            <!-- <tt-card ttHeading="Heading 1" ttTranslateHeading="false">
                    <tt-field-group>
                        <tt-select ttLabelView="top" ttLabel="fontfamily" [(ttModel)]="menu.heading1_fontfamily" style="min-width: 7rem"></tt-select>
                        <tt-select ttLabelView="top" ttLabel="fontstyle" [(ttModel)]="menu.heading1_fontstyle" style="min-width: 7rem"></tt-select>
                        <tt-select
                            ttLabelView="top"
                            ttLabel="textalign"
                            [(ttModel)]="menu.heading1_textalign"
                            [ttData]="textAligns"
                            (ttModelChange)="change$.next()"
                            style="min-width: 7rem"
                        ></tt-select>
                        <tt-input-number ttLabelView="top" ttLabel="fontsize" [(ttModel)]="menu.heading1_fontsize" (ttModelChange)="change$.next()" style="min-width: 7rem"></tt-input-number>
                    </tt-field-group>
                </tt-card>
                <tt-card ttHeading="Heading 2" ttTranslateHeading="false">
                    <tt-field-group>
                        <tt-select ttLabelView="top" ttLabel="fontfamily" [(ttModel)]="menu.heading2_fontfamily" style="min-width: 7rem"></tt-select>
                        <tt-select ttLabelView="top" ttLabel="fontstyle" [(ttModel)]="menu.heading2_fontstyle" style="min-width: 7rem"></tt-select>
                        <tt-select ttLabelView="top" ttLabel="textalign" [(ttModel)]="menu.heading2_textalign" style="min-width: 7rem"></tt-select>
                        <tt-input-number ttLabelView="top" ttLabel="fontsize" [(ttModel)]="menu.heading2_fontsize" style="min-width: 7rem"></tt-input-number>
                        <tt-input-color ttLabelView="top" ttLabel="textcolor"></tt-input-color>
                    </tt-field-group>
                </tt-card> -->
        </div>
        <div style="flex: 2">
            <object *ngIf="!!previewPdf" [data]="previewPdf" type="application/pdf" width="100%" height="100%"></object>
        </div>
    </div>
</ng-container>
